<template>
  <VisibleByVerizonChip
    v-if="hasPartnerPromoCode(partnerPromoCodes, 'VISIBLE')"
    :tracking-zone="`visible_${trackingZone}`"
  />

  <RakutenChip
    v-if="hasPartnerPromoCode(partnerPromoCodes, 'RAKUTEN')"
    :tracking-zone="`rakuten_${trackingZone}`"
  />
</template>

<script setup lang="ts">
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

import { hasPartnerPromoCode } from '~/scopes/product-core/utils/hasPartnerPromoCode/hasPartnerPromoCode'

import RakutenChip from './components/RakutenChip/RakutenChip.vue'
import VisibleByVerizonChip from './components/VisibleByVerizonChip/VisibleByVerizonChip.vue'

defineProps<{
  partnerPromoCodes: GetProductResponse['includedServiceOffers']['partnerPromoCodes']
  trackingZone: string
}>()
</script>
